import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./navbar.style.scss";
import OptionsPopup from "../optionsPopUp/optionsPopUp.comp";
import { UserContext } from "../../contexts/user.context";
import SignUpForm from "../signUpForm/signUpForm.comp";
import { getUserDoc } from "../../utils/firebase/firebase.utils";
import logo from '../../assets/logo.png';

const Navbar = ({
    option,
    homePage
}) => {

    const { currentUser, userID, profileImageUrl, setProfileImageUrl } = useContext(UserContext);

    useEffect(() => {
        const fetchProfileImage = async () => {
            if (userID) {
                const userDoc = await getUserDoc(userID);
                if (userDoc && userDoc.imageURL) {
                    setProfileImageUrl(userDoc.imageURL);
                }
            }
        };

        fetchProfileImage();
    }, [userID, setProfileImageUrl]);

    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const popupRef = useRef(null);

    const navigate = useNavigate();

    const navHome = () => {
        navigate(`/`);
    };

    const navToday = () => {
        navigate(`/today`);
    };

    const navThisWeek = () => {
        navigate(`/thisweek`);
    };

    const navNextWeek = () => {
        navigate(`/nextweek`);
    };

    const handleProfileClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        const popupWidth = 200; // Adjust this to your popup width
        setPopupPosition({ x: rect.right - popupWidth, y: rect.bottom });
        setShowPopup(true);
    };

    const handlePopupClose = () => {
        setShowPopup(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);


    //Pop Up: Sign Up
    const [displaySignUpForm, setDisplaySignUpForm] = useState(false)
    const handleSignUpPopUp = () => {
        setDisplaySignUpForm(true)
    }
    const handleCloseSignUpPopUp = () => {
        setDisplaySignUpForm(false)
    }

    return (
        <div>
            {/* Margin */}
            <div style={{ height: '20px' }}></div>

            {/* Navbar */}
            <div className="navbar">
                <div className="nav-left">
                    <div
                        className={`title-text-button${option === 0 ? `-clicked` : ''}`}
                        onClick={navHome}
                    >
                        {
                            homePage ? (
                                <div>
                                    <div
                                        style={{
                                            backgroundImage: `url('${logo}')`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            height: '40px',
                                            width: '40px',
                                            marginRight: '8px'
                                        }}
                                        onClick={navHome}
                                    />
                                    <h2 style={{ color: 'var(--fontlightblack1)' }}>Reeeach</h2>
                                </div>
                            ) : (
                                <div>
                                    <div
                                        style={{
                                            backgroundImage: `url('${logo}')`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            height: '40px',
                                            width: '40px',
                                            marginRight: '8px'
                                        }}
                                        onClick={navHome}
                                    />
                                    <h2 style={{ color: "grey" }}>Reeeach</h2>
                                </div>
                            )
                        }
                    </div>
                </div>
                {
                    currentUser ? (
                        <div className="nav-right">
                            <div
                                className={`text-button${option === 1 ? `-clicked` : ''}`}
                                onClick={navToday}
                                style={{ width: "90px" }}
                            >
                                <p>Today</p>
                            </div>
                            <div
                                className={`text-button${option === 2 ? `-clicked` : ''}`}
                                onClick={navThisWeek}
                            >
                                <p>This Week</p>
                            </div>
                            <div
                                className={`text-button${option === 3 ? `-clicked` : ''}`}
                                onClick={navNextWeek}
                            >
                                <p>Next Week</p>
                            </div>
                            <div
                                className={`text-button${option === 4 ? `-clicked` : ''}`}
                                onClick={handleProfileClick}
                            >
                                <p>···</p>
                            </div>
                            {

                            }
                            <div
                                className="profile-image"
                                style={{
                                    backgroundImage: `url(${profileImageUrl})`
                                }}
                                onClick={() => navigate('/settings')}
                            ></div>
                        </div>
                    ) : (
                        <div style={{ display: "flex", gap: '8px', alignItems: 'center' }}>
                            <p
                                style={{ cursor: "pointer" }}
                                onClick={handleSignUpPopUp}
                            >Sign In</p>
                            <div
                                style={{
                                    backgroundImage: `url(${'https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small_2x/user-profile-icon-free-vector.jpg'})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    aspectRatio: '1 / 1',
                                    height: '32px',
                                    cursor: 'pointer'
                                }}
                                onClick={handleSignUpPopUp}
                            >
                            </div>
                        </div>
                    )
                }
            </div>

            {/* Drop Down Options */}
            {
                showPopup && <OptionsPopup ref={popupRef} position={popupPosition} onClose={handlePopupClose} />
            }

            {/* SignUpPopUp */}
            {
                displaySignUpForm ? (
                    <SignUpForm closeForm={handleCloseSignUpPopUp} />
                ) : null
            }
        </div>
    );
};

export default Navbar;